<template>
    <div class="UserAccount">
      <div class="container">
        <div class="row">              
          <div class="col-md-12 totalform">
            <ValidationObserver ref="obsFieldsUpdate">
              <FormUpdateClient  v-if="renderComponent1" :FieldsForm="formUpdate" :ModelForm="formUpdModel" :method="executeProcess" />                   
            </ValidationObserver>
            <div class="col-md-6 float-left">
              <div class="alert alert-success refNoData" v-if="addRExito">El usuario se actualizo correctamente.</div>
              <div class="alert alert-danger refNoData" v-if="refNoUpdate">La actualizacion del usuario presento un fallo.</div>
              <div class="alert alert-danger refNoData" v-if="refWSUpdate">El servicio que ejecuta la actualización no se encuentra activo.</div>
            </div>
            <div class="float-right">                   
              <button type="submit" v-on:click="updateForm()" class="btn btn-lg btn-block botonRef" v-text="$ml.get('Update')"></button>
            </div>             
          </div>
        </div>
      </div>
    </div>    
</template>

<script>
import FormUpdateClient from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'Account',
  components:{
    FormUpdateClient
  },
  data() {
    return {
      formUpdModel: {
        idUpdatedBy: this.$session.get('IberoJWTLogin').idPerson,
        IdPerson: '',
        IdDocType: '',
        IdDocument: '',
        IdBanner: '',
        IdNombre: '',
        IdApellidos: '',
        IdAddress: '',
        IdMail: '',
        IdCelPhone: '',
        IdHomePhone: '',
        IdState: '',
        IdCity: '',
        IdFileDoc: '',
        IdTermiCondi: '',        
        IdNewsLetter: '',
        IdTransferCenter: [],
      }, 
      renderComponent1: false,
      addRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,      
      formUpdate:[       
        {            
          id: 'IdDocType',
          model: 'IdDocType',
          name: 'Tipo de identificación',
          type: 'Select',  
          placeholder: "Tipo de identificación",
          values: this.$store.state.DocTypesList,
          validate: {              
            required: true              
          },
          class: 'col-md-3'               
        },
        {            
          id: 'IdDocument',
          model: 'IdDocument',
          name: 'Documento de Identidad',
          type: 'input',  
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {              
            required: true, 
            max: 15            
          },
          class: 'col-md-3'               
        },
        {            
          id: 'IdBanner',
          model: 'IdBanner',
          name: 'Id Banner',
          type: 'informative',  
          placeholder: 'Id Banner',
          values: '',
          validate: {              
            required: false              
          },
          class: 'col-md-6'               
        },          
        {            
          id: 'IdNombre',
          model: 'IdNombre',
          name: 'Nombres',
          type: 'input',  
          placeholder: 'Nombres',
          values: '',
          validate: {              
            required: true              
          },
          class: 'col-md-6'               
        },  
        {            
          id: 'IdApellidos',
          model: 'IdApellidos',
          name: 'Apellidos',
          type: 'input',  
          placeholder: 'Apellidos',
          values: '',
          validate: {              
            required: true              
          },
          class: 'col-md-6'               
        },  
        {            
          id: 'IdAddress',
          model: 'IdAddress',
          name: 'Dirección',
          type: 'input',  
          placeholder: 'Dirección',
          values: '',
          validate: {
            required: true
          },
          class: 'col-md-6'               
        }, 
        {            
          id: 'IdMail',
          model: 'IdMail',
          name: 'Correo Electrónico',
          type: 'input',  
          placeholder: 'Correo Electrónico',
          values: '',
          validate: {
            required: true, 
            email: true 
          },
          class: 'col-md-6'               
        },  
        {            
          id: 'IdCelPhone',
          model: 'IdCelPhone',
          name: 'Teléfono Celular',
          type: 'input',  
          placeholder: 'Teléfono Celular',
          values: '',
          validate: {
            required: true, 
            numeric: true,
            max: 10
          },  
          class: 'col-md-3'               
        },      
        {            
          id: 'IdHomePhone',
          model: 'IdHomePhone',
          name: 'Teléfono Fijo',
          type: 'input',  
          placeholder: 'Teléfono Fijo',
          values: '',
          validate: {
            required: false, 
            numeric: true,
            max: 7 
          },         
          class: 'col-md-3'               
        },                      
        {
          id: 'IdState',
          model: 'IdState',
          name: 'Departamento',
          type: 'Select',  
          placeholder: 'Departamento',
          class: 'col-md-3',            
          values: this.$store.state.StateList,
          validate: {              
            required: true              
          },
        },
        {
          id: 'IdCity',
          model: 'IdCity',
          name: 'Ciudad',
          type: 'Select',  
          placeholder: 'Ciudad',
          validate: {              
            required: true              
          },
          class: 'col-md-3',            
          values: this.$store.state.CityList,
        },
        {
         id: 'IdFileDoc',
          model: 'IdFileDoc',
          name: 'Archivo',
          type: 'file',  
          placeholder: 'Archivo',
          validate: {              
            required: false              
          },
          class: 'col-md-6',            
          values: '',
        },        
        {            
          id: 'IdNewsLetter',
          name: 'Informacion Comercial',
          model: 'IdNewsLetter',
          type: 'accepted',  
          placeholder: 'Recibir informacion comercial',
          disabled: false,
          validate: {              
            required: false,
          },
          class: 'col-md-12 linkref'                
        },        
        {            
          id: 'IdTermiCondi',
          name: 'Politicas de privacidad',
          model: 'IdTermiCondi',
          type: 'accepted',  
          placeholder: 'He leído y acepto las <a class="linkTerm" href="https://ibero.edu.co/tratamiento-uso-datos-personales" target="_blank">politicas de privacidad</a> de protección de datos.',          
          disabled: false,
          validate: {              
            required: true,
          },
          class: 'col-md-12 linkref'                
        }                          
      ]
    }
  },
  methods:{
   limpiaref () {
      this.addRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
    },    
    updateForm(){   
      this.limpiaref()
      var updateval = new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {         
          if (!results) {            
            resolve(false)
          }else{
            let loader = this.$loading.show()
            var totalinf = IberoHelpers.sendFormUpdate(this.$store, this.formUpdModel)
            totalinf.then(Response => {
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.renderComponent1 = false
                this.addRExito = true
                var logininf = IberoHelpers.getUserLogin(this.$store,this.$session.get("IberoJWT").upn);
                logininf.then(Response => {
                  if (Response === false) {
                    resolve(false)
                  } else {
                    this.$session.set("IberoJWTLogin", "");
                    this.$session.set("IberoJWTLogin", Response.data);
                    this.callLoadData()
                  }
                  loader.hide();
                });                     
                IberoHelpers.forceRerender1(this)            
                resolve(true)
              }              
              loader.hide()         
            })  
          }
        });
      });         
    },
    executeProcess: function (event) {   
      switch (event.target.id) {
        case "IdState":
          this.formUpdModel.IdCity = '';
          if(event.target.value === ''){            
            this.formUpdate[10].values = '';
          }else{
            IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityList,event.target.value);
            this.formUpdate[10].values = this.$store.state.CityList;
          }
        break;
        case "cbox_IdTermiCondi":
            event.target.disabled = true;
        break;
        return true;
      }          
    },
    callLoadData: function(){
     IberoHelpers.getCitiesListByState(
        this.$store.state.ApiIbero.WSParametric,
        this.$store.state.CityList,
        this.$session.get("IberoJWTLogin").codResidenceDepartment
      )
      this.formUpdModel.IdPerson =  this.$session.get("IberoJWTLogin").idPerson
      this.formUpdModel.IdDocType = this.$session.get("IberoJWTLogin").idDocumentType
      this.formUpdModel.IdDocument = this.$session.get("IberoJWTLogin").numDocument
      this.formUpdModel.IdBanner = this.$session.get("IberoJWTLogin").idBanner
      this.formUpdModel.IdNombre = this.$session.get("IberoJWTLogin").namPerson
      this.formUpdModel.IdApellidos = this.$session.get("IberoJWTLogin").lastNamePerson
      this.formUpdModel.IdAddress = this.$session.get("IberoJWTLogin").resAddress

      this.formUpdModel.IdTermiCondi = this.$session.get("IberoJWTLogin").termsConditions
      this.formUpdate[13].disabled = this.$session.get("IberoJWTLogin").termsConditions
      this.formUpdModel.IdNewsLetter = this.$session.get("IberoJWTLogin").infReceive

      this.formUpdModel.IdHomePhone = ''
      this.formUpdModel.IdCelPhone = ''
      this.formUpdModel.IdMail = ''

      for (var i = 0; i < this.$session.get("IberoJWTLogin").information.length; i++) {
        if (this.$session.get("IberoJWTLogin").information[i].idContactType === 1) {
          this.formUpdModel.IdHomePhone = this.$session.get("IberoJWTLogin").information[i].desContactInformation
        } else if (this.$session.get("IberoJWTLogin").information[i].idContactType === 2) {
          this.formUpdModel.IdCelPhone = this.$session.get("IberoJWTLogin").information[i].desContactInformation
        } else if (this.$session.get("IberoJWTLogin").information[i].idContactType === 3) {
          this.formUpdModel.IdMail = this.$session.get("IberoJWTLogin").information[i].desContactInformation
        }
      }

      this.formUpdModel.IdState = this.$session.get("IberoJWTLogin").codResidenceDepartment
      this.formUpdModel.IdCity = this.$session.get("IberoJWTLogin").codResidenceCity

      this.formUpdModel.IdTransferCenter = this.$session.get("IberoJWTLogin").transferCenterModels

    }
  },
  created: function () {    
    if (!this.$session.get('IberoJWTLogin')) {
      this.$router.push('Login')
    } else {
      this.callLoadData();
      IberoHelpers.forceRerender1(this) 
    }   
  }
}
</script>

<style>

.totalform {
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;  
  background-color: #ffffff;
}
.botonRef{
  margin-top: 5px;
  max-width: 200px;
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}

.formcenter{ 
  display: grid;
  margin-left: 20%;
}

#div_IdTermiCondi .titleRef{
  color: #ffffff;  
  display: none;
}

#div_IdNewsLetter .titleRef{
  color: #ffffff;
  margin-top: -2px;  
}

.refNoData {
  font-weight: bold;
  padding: 10px;
  padding-left: 20px;
}

</style>